export const ESIGN_PROVIDER_HELLOSIGN = 20;
export const ESIGN_PROVIDER_BLUE_MOON = 30;

export const ESIGN_PROVIDER_CHOICES = {
    [ESIGN_PROVIDER_HELLOSIGN]: 'Hello Sign',
    [ESIGN_PROVIDER_BLUE_MOON]: 'Blue Moon',
};
